import Userlabel from "@/components/AvatarComponent/Userlabel";
import UsersLabeled from "@/components/AvatarComponent/UsersLabeled";
import { ObjectId } from "@/model/db/General";
import BfIcon from "@/modules/abstract-ui/icon/BfIcon";
import { DefaultIcons } from "@/modules/abstract-ui/icon/DefaultIcons";
import classNames from "classnames";
import { Tag } from "rsuite";
import i18n from "../../../../i18n";
import { BFAssignmentSearch } from "../../../abstract-ui/forms/assignment/BFAssignmentSearch";
import BFButton from "../../../abstract-ui/general/Button/BFButton";
import "./EZMultipleAssignment.scss";

interface EZAssignmentProps {
  block?: boolean;
  className?: string;
  value: ObjectId[]; // Updated type to ObjectId[]
  onChange: (value: ObjectId[]) => void;
  onBlur?: (ev, value: ObjectId[]) => void; // Updated parameter type to ObjectId[]

  error?: string;
  disabled?: boolean;
  identifier?: string;
  type: "user" | "team" | "both";
  teamContexts?: string[];
  readonly?: boolean;
}
const EZMultipleAssignment = (props: EZAssignmentProps) => {
  const renderValue = () => {
    return (
      <>
        {props.value && props.value.length > 0 && (
          <UsersLabeled userIds={props.value} avatarSize={18} />
        )}
        {!props.value || props.value.length === 0 ? (
          <div className={`not-assigned`}>
            {i18n.t("EZAssignment.not-assigned", "Nicht zugeordnet")}
          </div>
        ) : null}
      </>
    );
  };

  if (props.readonly) {
    return (
      <div
        className={classNames(`ez-multiple-assignment`, { block: props.block })}
      >
        <Tag className={`readonly-tag`} size="lg">
          {renderValue()}
        </Tag>
      </div>
    );
  }

  return (
    <div
      className={classNames(`ez-multiple-assignment`, { block: props.block })}
    >
      <BFAssignmentSearch
        overlayClassName={`ez-multiple-assignment-search`}
        renderTopNode={
          props.value?.length > 0
            ? () => (
                <div className={`current-nodes`}>
                  {props.value.map((id) => (
                    <div className={`user-entry`} key={id}>
                      <div className={`user-name`}>
                        <Userlabel id={id} avatarSize={18} />
                      </div>
                      <BFButton
                        className={`remove-button`}
                        appearance="link"
                        size="xs"
                        noPadding
                        disabled={props.disabled}
                        onClick={() => {
                          const newValue = props.value.filter(
                            (value) => value !== id
                          );
                          props.onChange(newValue);
                          props.onBlur(null, newValue);
                        }}
                      >
                        <BfIcon {...DefaultIcons.CLOSE} size="xxs" />
                      </BFButton>
                    </div>
                  ))}
                </div>
              )
            : undefined
        }
        asOverlay
        identifier={props.identifier}
        teamContexts={props.teamContexts}
        text={"test"}
        type={props.type}
        onSelect={(assignment) => {
          props.onChange([...(props.value || []), assignment.id]);
          props.onBlur(null, [...(props.value || []), assignment.id]);
        }}
        value={props.value && props.value.length > 0 ? props.value : []}
        renderToggle={(toggleProps, ref) => (
          <BFButton {...toggleProps} disabled={props.disabled}>
            {renderValue()}
          </BFButton>
        )}
        onlyActive={true}
      />
    </div>
  );
};

export default EZMultipleAssignment;
